import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class FaqWidgetService {
  private openSubject = new BehaviorSubject<boolean>(false);
  isOpen$ = this.openSubject.asObservable();

  open(): void  { this.openSubject.next(true); }
  close(): void { this.openSubject.next(false); }
  toggle(): void { this.openSubject.next(!this.openSubject.value); }
}
